/**
 * Shared email validation for login and signup flows.
 * Use this utility whenever an email must be validated (e.g. on form submit).
 */

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns true if the trimmed string is a valid email format.
 */
export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && emailRegex.test(trimmed);
}
